<template>
  <div id="loy">
    <div class="sky">
      <div class="sun"></div>
      <div class="oblako o5">
        <div class="o_container5">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o4">
        <div class="o_container4">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o3">
        <div class="o_container3">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o2">
        <div class="o_container2">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>
      <div class="oblako o1">
        <div class="o_container1">
          <div class="ob1"></div>
          <div class="ob2"></div>
          <div class="ob3"></div>
          <div class="ob4"></div>
          <div class="ob5"></div>
        </div>
      </div>

      <!-- tree -->

      <!-- <div class="tree"></div> -->

      <!-- temple -->
    </div>

    <!-- wave -->
    <div class="waves">
      <div class="temple"></div>
      <div class="wave"></div>
      <div class="wave"></div>
      <!-- <div class="wave"></div> -->
      <div class="wave"></div>
      <div class="wave"></div>

      <!-- krathong .slice(0, 7)-->
      <div
        v-for="(item, index) in newname"
        :key="index"
        :class="[`krathongs-${index}`]"
      >
        <div :class="[`krathongs_container-${index}`]">
          <!-- <img :src=randomImage alt=""> -->
          <!-- <img
          :src="'https://opac.ubru.ac.th/img/krathong_' + index + '.png'"
          width="150"
          height="150"
          alt=""
         
        /> -->
          <img
            :src="'https://opac.ubru.ac.th/img/krathong_' + index + '.png'"
            width="200"
            height="200"
            alt=""
          />

          <div class="" style="text-align: center; position: absolute">
            <h6
              style="
                background-color: pink;
                margin-top: -100px;
                z-index: 999;

                color: rgb(1, 17, 31);
                border-radius: 30px;
                padding: 5px 10px;
              "
            >
              {{ item }}
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "loy",
  data() {
    return {
      images: [
        "https://usl.ubru.ac.th/img/krathong-item16.png",
        "krathong-item18.png",
        "c6.png",
        "bf5vg47cih.png",
      ],
      token: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      namestd: {},
      newname: [],
      // randomImage: null,
    };
  },

  methods: {
    setTimeDelay(name,i){
      setTimeout(() => 
      this.newname.push(name)
      , 5000 * i);
      
    },
    randomImage() {
      return require(`${
        this.images[Math.floor(Math.random() * this.images.length)]
      }`);
    },
    get_name() {
    
      const token = this.token;
      const data = {
        num_of_std: "", 
      };
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/miracle/get_student_random",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          const chkstatus = res.data.msg.status;
          // console.log(chkstatus);

          if (chkstatus === 200) {
            this.namestd = res.data.student_datas;
            // console.log(this.namestd.length, "for");
          
            for (var i = 0; i < this.namestd.length ; i++) {
              // console.log(this.namestd[i].std_name);
              // this.setTimeDelay(this.namestd[i].std_name,i);
            
            }

            /*  this.namestd.forEach((item) => {
              setInterval(()=>{
                this.newname.push(item.std_name);
            },5000);
             
            console.log(this.namestd);
            });*/

            /**/
          } else {
            console.log(res.data.msg.message);
          }
        });
   
      },
  },
  mounted() {
    this.get_name();
    setInterval(() => {
      this.get_name();
    }, 10000);
  },
};
</script>

<style scoped>

@keyframes sunshining {
  from {
    box-shadow: 0 0 20px 10px #f9ff54, 0 0 20px 10px #fff;
  }
  50% {
    box-shadow: 0 0 30px 15px #fbff81, 0 0 40px 20px #fff;
  }
  to {
    box-shadow: 0 0 20px 10px #f9ff54, 0 0 20px 10px #fff;
  }
}

/*Sky*/
.sky {
  position: relative;
  height: 560px;
  background-image: linear-gradient(
    to top,
    #a262b0,
    #884e9d,
    #6e3c8a,
    #552978,
    #3b1866
  );
  z-index: 0;
}

.sun {
  position: absolute;
  top: 70px;
  left: 50%;
  margin-left: -30px;
  height: 60px;
  width: 60px;
  background: yellow;
  border-radius: 30px;
  box-shadow: 0 0 20px 10px #f9ff54;
  animation: sunshining 4s infinite linear;
}

/*END*/

/* clound */

.oblako {
  position: absolute;
}

.o1 {
  top: 50px;
  left: -100px;
}
.o2 {
  top: 100px;
  left: -100px;
}
.o3 {
  top: 150px;
  left: -100px;
}
.o4 {
  top: 200px;
  left: -100px;
}
.o5 {
  top: 250px;
  left: -100px;
}

.ob1 {
  width: 50px;
  height: 50px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  left: 20px;
  top: 10px;
  border-radius: 25px;
  background: #bbbbbb;
}

.ob2 {
  width: 40px;
  height: 40px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  left: 90px;
  top: 20px;
  border-radius: 20px;
  background: #bbbbbb;
}

.ob3 {
  width: 30px;
  height: 30px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  top: 30px;
  left: 120px;
  border-radius: 15px;
  background: #bbbbbb;
}

.ob4 {
  width: 20px;
  height: 20px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  top: 40px;
  border-radius: 10px;
  background: #bbbbbb;
}

.ob5 {
  width: 60px;
  height: 60px;
  box-shadow: 0 0 10px 8px #929292, 0 5px 10px #ccc;
  position: absolute;
  left: 50px;
  border-radius: 30px;
  background: #bbbbbb;
}

@keyframes skymove {
  from {
    transform: translateX(-200px);
  }
  to {
    transform: translateX(110vw);
  }
}

@keyframes skyscalefirst {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1);
  }
}
@keyframes skyscalesecond {
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(0.8);
  }
}
@keyframes skyscalethird {
  from {
    transform: scale(0.6);
  }
  to {
    transform: scale(0.6);
  }
}
@keyframes skyscalefourth {
  from {
    transform: scale(0.4);
  }
  to {
    transform: scale(0.4);
  }
}
@keyframes skyscalefifth {
  from {
    transform: scale(0.2);
  }
  to {
    transform: scale(0.2);
  }
}

.o1 {
  animation: skymove 40s infinite linear;
}
.o_container1 {
  animation: skyscalefirst 40s infinite linear;
}

.o2 {
  animation: skymove 60s infinite linear;
}
.o_container2 {
  animation: skyscalesecond 60s infinite linear;
}

.o3 {
  animation: skymove 80s infinite linear;
}
.o_container3 {
  animation: skyscalethird 80s infinite linear;
}

.o4 {
  animation: skymove 100s infinite linear;
}
.o_container4 {
  animation: skyscalefourth 100s infinite linear;
}

.o5 {
  animation: skymove 120s infinite linear;
}
.o_container5 {
  animation: skyscalefifth 120s infinite linear;
}

/* END */
/* tree*/
@-webkit-keyframes ani_tem {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1870px;
  }
}

@keyframes ani_tem {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1870px;
  }
}
.tree {
  width: 100%;
  height: 500px;
  position: absolute;
  /*background-image: url(../../../assets/loykrathong/58380.png);*/
  z-index: 6;
  opacity: 0.4;
  background-size: cover;
  background-repeat: repeat-x;
  bottom: -10px;
  /*-webkit-animation: ani_tem 25s linear 0s infinite normal none running ;
 animation:   ani_tem 25s linear 0s infinite normal none running;*/
}
/*END*/
/* temple*/
.temple {
  bottom: 400px;
  width: 100%;
  height: 600px;
  position: absolute;

  background-image: url(../../../assets/loykrathong/loyy.png);
  z-index: 8;
  background-size: cover;
  background-repeat: repeat-x;
}

/* END*/
/* sea */
.waves {
  position: relative;
  height: 450px;
  /* background: #1b2d48; */
  z-index: 0;
  margin-top: 50px ;
}

.wave {
  position: absolute;
  left: 0;
  bottom: 0;
  height: auto;
  width: 100%;
  /* background-repeat: repeat-x, no-repeat; */
}

/* .wave:nth-child(1) {
  z-index: 10;
  height: 140px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(66,165,245)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#42a5f5, #42a5f5);
  background-size: 140px 170px, 200% 100%;
  background-position: 0 0, 0 100px;
  animation: ani_wave1 2s linear alternate infinite;
} */

.wave:nth-child(2) {
  z-index: 20;
  height: 220px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(60,100,159)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#3c649f, #3c649f);
  background-size: 200px 140px, 200% 100%;
  background-position: 0 0, center 95px;
  background-repeat: repeat-x;
  -webkit-animation: 25s linear 0s infinite normal none running ani_wave;
  animation: 20s linear 0s infinite normal none running ani_wave;
}
.wave:nth-child(3) {
  z-index: 13;
  height: 310px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(44,69,107)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(#2c456b, #2c456b);
  background-size: 160px 50px, 200% 100%;
  background-position: 0 0, center 40px;
  background-repeat: repeat-x;
  -webkit-animation: 35s linear 0s infinite normal none running ani_wave;
  animation: 40s linear 0s infinite normal none running ani_wave;
}
.wave:nth-child(4) {
  z-index: 7;
  height: 450px;
  /* background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(25,118,210)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
      linear-gradient(to right, #1976d2, #1976d2); */
  /* background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(25,118,210)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
      linear-gradient(to right, #421a7f, #421a7f); */
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(27,45,72)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
    linear-gradient(to right, #1b2d48, #1b2d48);

  background-size: 0px 60px, 200% 100%;
  background-position: 0 0, 0 35px;
  background-repeat: repeat-x;
  /*-webkit-animation: 25s linear 0s infinite normal none running ani_wave;
  animation: 25s linear 0s infinite normal none running ani_wave;*/
}
/* .wave:nth-child(5) {
      z-index: 4;
      height: 400px;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 6.7"><path style="fill:rgb(	21, 99, 177)" d="M0 6.7v-4s5.4-5.9 12.7-.2 12.3.2 12.3.2v4H0z"/></svg>'),
       linear-gradient(to right, #1563b1, #1563b1);
      background-size: 90px 25px, 200% 100%;
      background-position: 0 0, 0 20px;
      animation: ani_wave5 2s linear alternate infinite;
    } */
@keyframes ani_wave1 {
  /* 0% {
      background-position-x: 0;
    }
    100% {
      background-position-x: -100px;
    } */
}

@-webkit-keyframes ani_wave {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 1080px;
  }
}

@keyframes ani_wave {
  from {
    /* transform: translateX(-50px); */
    background-position-x: 0;
  }
  to {
    /* transform: translateX(50vw); */
    background-position-x: 1080px;
  }
}
/* 
  @keyframes ani_wave2 {
    0% {transform: translateX(0);}
      50% {transform: translateX(25%);}
      100% {transform: translateX(50%);}
     0% {
      background-position-x: -90px;
    }
    100% {
      background-position-x: 0;
    } 
  } */
@keyframes ani_wave3 {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: -70px;
  }
}
@keyframes ani_wave4 {
  0% {
    background-position-x: -50px;
  }
  100% {
    background-position-x: 0;
  }
}
@keyframes ani_wave5 {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: -70px;
  }
}

/*end */

/*=============== Styles for krathongs =================*/

.krathongs-0 {
  position: absolute;
  bottom: 280px;
  z-index: 10;
}

.krathongs-1 {
  position: absolute;
  bottom: 150px;
  z-index: 17;
}
.krathongs-2 {
  position: absolute;
  bottom: 140px;
  z-index: 16;
}

.krathongs-3 {
  position: absolute;
  bottom: 260px;
  z-index: 9;
}

.krathongs-4 {
  position: absolute;
  bottom: 150px;
  z-index: 15;
}

.krathongs-5 {
  position: absolute;
  bottom: 260px;
  z-index: 8;
}

.krathongs-6 {
  position: absolute;
  bottom: 150px;
  z-index: 14;
}

.krathongs-7 {
  position: absolute;
  bottom: 270px;
  z-index: 8;
}
.krathongs-8 {
  position: absolute;
  bottom: 270px;
  z-index: 8;
}
.krathongs-9 {
  position: absolute;
  bottom: 100px;
  z-index: 13;
}
.krathongs-10 {
  position: absolute;
  bottom: 150px;
  z-index: 50;
}

@keyframes krathongsrotate {
  from {
    transform: rotate(0deg);
    transform-origin: 20% 100%;
  }
  25% {
    transform: rotate(2deg);
    transform-origin: 20% 100%;
  }
  75% {
    transform: rotate(-4deg);
    transform-origin: 20% 100%;
  }
  to {
    transform: rotate(0deg);
    transform-origin: 20% 100%;
  }
}

@keyframes krathongsmove {
  from {
    transform: translateX(-310px);
  }
  to {
    transform: translateX(110vw);
  }
}

.krathongs-0 {
  animation: krathongsmove 65s infinite linear;
}

.krathongs_container-0 {
  animation: krathongsrotate 5s infinite linear;
}

.krathongs-1 {
  animation: krathongsmove 70s infinite linear;
}

.krathongs_container-1 {
  animation: krathongsrotate 4.5s infinite linear;
}

.krathongs-2 {
  animation: krathongsmove 90s infinite linear;
}

.krathongs_container-2 {
  animation: krathongsrotate 6s infinite linear;
}

.krathongs-3 {
  animation: krathongsmove 80s infinite linear;
}

.krathongs_container-3 {
  animation: krathongsrotate 6.2s infinite linear;
}

.krathongs-4 {
  animation: krathongsmove 110s infinite linear;
}

.krathongs_container-4 {
  animation: krathongsrotate 5s infinite linear;
}
.krathongs-5 {
  animation: krathongsmove 100s infinite linear;
}

.krathongs_container-5 {
  animation: krathongsrotate 7s infinite linear;
}
.krathongs-6 {
  animation: krathongsmove 130s infinite linear;
}

.krathongs_container-6 {
  animation: krathongsrotate 6.5s infinite linear;
}
.krathongs-7 {
  animation: krathongsmove 140s infinite linear;
}

.krathongs_container-7 {
  animation: krathongsrotate 7s infinite linear;
}
.krathongs-8 {
  animation: krathongsmove 120s infinite linear;
}

.krathongs_container-8 {
  animation: krathongsrotate 6s infinite linear;
}
.krathongs-9 {
  animation: krathongsmove 150s infinite linear;
}

.krathongs_container-9 {
  animation: krathongsrotate 7s infinite linear;
}
.krathongs-10 {
  animation: krathongsmove 40s infinite linear;
}

.krathongs_container-10 {
  animation: krathongsrotate 4.5s infinite linear;
}
/*end*/
</style>